document.addEventListener('DOMContentLoaded', function () {
  var track = document.getElementById('qfs-slider-track');
  if (!track) return;

  var slides = track.querySelectorAll('.slider-slide');
  var prevBtn = document.getElementById('qfs-prev-btn');
  var nextBtn = document.getElementById('qfs-next-btn');
  var dotsContainer = document.getElementById('qfs-slider-dots');
  var currentIndex = 0;
  var totalSlides = slides.length;

  for (var i = 0; i < totalSlides; i++) {
    var dot = document.createElement('button');
    dot.classList.add('slider-dot');
    if (i === 0) dot.classList.add('active');
    dot.setAttribute('aria-label', 'Go to ' + (i + 1));
    dot.addEventListener(
      'click',
      (function (idx) {
        return function () {
          goToSlide(idx);
        };
      })(i)
    );
    dotsContainer.appendChild(dot);
  }

  var dots = dotsContainer.querySelectorAll('.slider-dot');

  function updateSlider() {
    track.style.transform = 'translateX(-' + currentIndex * 100 + '%)';
    dots.forEach(function (d, i) {
      d.classList.toggle('active', i === currentIndex);
    });
    if (prevBtn) prevBtn.disabled = currentIndex === 0;
    if (nextBtn) nextBtn.disabled = currentIndex === totalSlides - 1;
  }

  function goToSlide(i) {
    currentIndex = i;
    updateSlider();
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) {
        currentIndex--;
        updateSlider();
      }
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      if (currentIndex < totalSlides - 1) {
        currentIndex++;
        updateSlider();
      }
    });
  }

  var touchStartX = 0;
  track.addEventListener(
    'touchstart',
    function (e) {
      touchStartX = e.changedTouches[0].screenX;
    },
    { passive: true }
  );
  track.addEventListener(
    'touchend',
    function (e) {
      var diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 50) {
        if (diff > 0 && currentIndex < totalSlides - 1) currentIndex++;
        else if (diff < 0 && currentIndex > 0) currentIndex--;
        updateSlider();
      }
    },
    { passive: true }
  );

  updateSlider();
});
